import { useLocation } from "react-router";

import { t } from "i18next";

import { Box } from "@mui/material";

import WeBuyCarsPage from "@/src/pages/consumer/WeBuyCars";

import { PublicRoute } from "@/src/auth/components/PublicRoute";
import { findCityByPath } from "@/src/utils/weBuyCarsLandingPages";

import { loadDealerLogoRouteData } from "../dealerLogoRouteData";
import { buildWeBuyCarsMeta } from "../weBuyCarsMeta";
import type { Route } from "./+types/ostetaan-autoja";

// Runs at build time (ssr:false + prerender) so the static HTML carries the
// dealer names and logo markup; images still load lazily in the browser.
export async function loader() {
  return loadDealerLogoRouteData();
}

// Client-side navigations reuse the prerendered data when available. No
// `hydrate = true`, so the initial render uses the inlined build-time data.
export async function clientLoader({ serverLoader }: Route.ClientLoaderArgs) {
  try {
    return (await serverLoader()) as Awaited<ReturnType<typeof loader>>;
  } catch {
    return loadDealerLogoRouteData();
  }
}

export const meta: Route.MetaFunction = ({ location }) => {
  const city = findCityByPath(location.pathname);
  const title = t(
    city
      ? "components.weBuyCarsPage.metaTitleWithCity"
      : "components.weBuyCarsPage.metaTitle",
    { cityName: city }
  );
  const description = t(
    city
      ? "components.weBuyCarsPage.metaDataWithCity"
      : "components.weBuyCarsPage.metaData",
    { cityName: city }
  );

  return buildWeBuyCarsMeta({
    pathname: location.pathname,
    title,
    description,
    landingName: city?.basic,
    kind: "city"
  });
};

export default function OstetaanAutojaRoute({
  loaderData
}: Route.ComponentProps) {
  const { pathname } = useLocation();
  const city = findCityByPath(pathname);

  return (
    <PublicRoute routeType="consumer" renderWhileAuthenticating>
      <Box sx={{ display: "flex", flex: "1" }}>
        <WeBuyCarsPage cityName={city} dealerLogos={loaderData} />
      </Box>
    </PublicRoute>
  );
}
